export default {
  TIMER_MIN: 1000 * 60 * 15
}
